import React from 'react';
import ReactDOM from 'react-dom';
import MobileSideMenu from '../customer_pages/_megamenu/mobile-side-menu';

document.addEventListener('DOMContentLoaded', () => {
  const node = document.getElementById('mobile-side-menu');
  if (!node) return;

  const data = JSON.parse(node.getAttribute('data-ssr-props') || '{}');

  ReactDOM.hydrate(<MobileSideMenu {...data} />, node);
});
